import React, { useEffect, useState } from "react";
import PageData from "../util/data/data.json";
import FoodSections from "../components/FoodSections";
import CallToAction from "../components/CallToAction";
import FoodCategory from "../components/FoodCategory";
import apiClient from "../api/axios";
import {
  getRecipeParamsForSweets,
  getRecipeParamsForSuperDelicious,
} from "../util/helper";
import { Link } from "react-router-dom";

const { foodCategory } = PageData;

const Index = () => {
  const [sweetsRecipe, setSweetsRecipe] = useState([]);
  const [superDelicious, setSuperDelicious] = useState([]);

  useEffect(() => { 
    apiClient
      .get(null, getRecipeParamsForSweets())
      .then((res) => {
        setSweetsRecipe(res.hits);
      })
      .catch((error) => console.error(error));

    apiClient
      .get(null, getRecipeParamsForSuperDelicious())
      .then((res) => {
        setSuperDelicious(res.hits);
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <div className="overflow-hidden">
      <div className="w-full mx-auto bg-slate-200 min-h-[calc(100dvh-45px)] flex items-center ">
        <div className="md:w-5/6 w-11/12 mx-auto max-w-7xl flex items-center">
          <div className="md:w-1/2 text-left space-y-5 ">
            <h1 className="text-3xl leading-9">
              Your Daily Dish
              <br /> A Food Journey
            </h1>
            <p>
              Welcome to Your Daily Dish, where every recipe is a new adventure.
              Discover flavors from around the world and bring excitement to
              your kitchen with easy-to-follow recipes that delight your taste
              buds.
            </p>
            <Link to="/recipes">
              <button className="py-1.5 px-3 mt-5 bg-blue-400 rounded-lg text-base text-white font-light">
                See More
              </button>
            </Link>
          </div>
          <div className="w-1/2 hidden md:block">
            <img src="/images/recipe-home.svg" alt="Recipe App" />
          </div>
        </div>
      </div>
      <FoodSections recipeList={superDelicious} title="Quick Bites" size={6} />
      <hr />
      <FoodSections recipeList={sweetsRecipe} title="Sweet Tooth" size={6} />
      <CallToAction />
      <FoodCategory category={foodCategory} title="Food Categories" />
    </div>
  );
};

export default Index;
